import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'
import ScrollNavbar from '../components/ScrollNavbar'

const ThankyouPage = () => {
  return (
    <div>
      <ScrollNavbar/>
        <Navbar/>
        <div className="confirm-booking">
        <div className="confirm-booking-heading-1">Your Pet Grooming Service Is Confirmed</div>
        <div className="confirm-booking-heading-2">Our expert will contact you shortly</div>
        {/* <div className='conf-booking-thanks-note' > <span> <i class="fa-solid fa-lightbulb"></i> </span> We groom inside your home — not in a van. No mess left behind. Happy pets, even happier place. </div> */}
        {/* <div className="confirm-booking-heading-3">Contact : <Link target='blank' to="tel:+91-9658-189-189">+91 9658-189-189</Link></div> */}
        <br />
        <div className="confirm-booking-link"><Link onClick={() =>  window.history.back()}>Go Back</Link></div>
        <br />
        <div className="confirm-booking-link"><Link to="tel:+919658189189" target="_blank"><i className="fa-solid fa-phone"></i> Book By Call</Link></div>

        </div>
        <Footer/>
    </div>
  )
}

export default ThankyouPage